import { Button, ListItem, ListItemText, Stack, SxProps, Typography } from "@mui/material";
import React from "react";
import ImagePicker from "../atoms/ImagePicker";

interface ImagePickerFormListItemProps {
    text: string,
    initialValue: string,
    onSave?: (value: string) => void
    onChange?: (value: string) => void,
    imagePickerSx?: SxProps,
    imageSx?: SxProps,
    error?: boolean,
    helperText?: string
}

const ImagePickerFormListItem: React.FC<ImagePickerFormListItemProps> = ({
    text,
    initialValue,
    onSave,
    imagePickerSx,
    imageSx,
    error,
    helperText,
}) => {
    const [value, setValue] = React.useState(initialValue)

    React.useEffect(()=>{
        setValue(initialValue)
    },[initialValue])

    return (
        <ListItem>
            <ListItemText primary={text} />
            <Stack
                direction={"column"}
            >
                <ImagePicker
                    sx={imagePickerSx}
                    imageSx={imageSx}
                    imageData={value}
                    onChange={(data) => {
                        setValue(data)
                    }}
                />
                {helperText &&
                    <Typography variant="body2">{helperText}</Typography>
                }
            </Stack>
            {onSave &&
                <Button
                    variant="outlined"
                    sx={{ marginLeft: "1em" }}
                    onClick={() => {
                        onSave(value)
                    }}
                    disabled={error}
                >保存</Button>
            }
        </ListItem>
    );
}

export default ImagePickerFormListItem